import { useAppSelector } from "hooks/redux"
import { useModelMetadata } from "resources/models"
import { useDisplayCurrency } from "resources/currencies"
import { getIsFxHedgeSupportedByModel } from "connected-components/compare/position-sets"
import { OK } from "helpers/data-statuses"
import { useDashboardId } from "../context/dashboard-id"
import { DEFAULT_CORE_STATE } from "../store/core-slice"
import { resolveFxHedgeEnabled } from "../helpers"

export interface MainInstrumentFxHedge {
  isFxHedged: boolean
  isFxHedgeSupported: boolean
  isFxHedgeSupportKnown: boolean
}

export function useMainInstrumentFxHedge(
  instrumentMetadata: { type?: string, fxHedgeEnabled?: boolean } | null | undefined,
): MainInstrumentFxHedge {
  const dashboardId = useDashboardId()
  const { instrument: mainInstrument } = useAppSelector((s) => s.dashboard.core[dashboardId] ?? DEFAULT_CORE_STATE)
  const modelId = useAppSelector((s) => s.dashboard.model[dashboardId]?.modelId ?? null)
  const [modelMetadata] = useModelMetadata(modelId as string)
  // Currency comes from the main instrument itself here — this badge is read-only, unlike compare's toggle.
  const [currency, currencyStatus] = useDisplayCurrency(modelId, mainInstrument)
  const isFxHedgeSupported = getIsFxHedgeSupportedByModel(modelMetadata?.factors, currency)

  return {
    isFxHedged: resolveFxHedgeEnabled(instrumentMetadata) && isFxHedgeSupported,
    isFxHedgeSupported,
    // useResource returns [null, OK] (not LOADING) for a falsy id, so require modelId/mainInstrument too.
    isFxHedgeSupportKnown: Boolean(modelId) && Boolean(mainInstrument) && currencyStatus === OK,
  }
}
